import { useEffect, useState } from "react";
import { useForm, Controller } from 'react-hook-form'
import DatePicker from "react-multi-date-picker";
import moment from 'moment/moment';

import Modal from '../Modal';
import { taskSizes } from "../../services/EnumsService";
import { createTaskProject } from "../../api/project.api";
import { getTask, updateTask } from "../../api/tasks.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";

export function TaskModal({ project, taskId, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const [sizes, setSizes] = useState([])
    const[task, setTask] = useState({})
    const {category, refreshProjectsCategory} = CategoryData();

    const getTaskError = error => {
        setTask({})
        showError(`Error al recuperar la tarea. ${error.message}`)
    }

    useEffect(() => {
        async function loadSizes() {
            setSizes(taskSizes())
        }
        async function loadTask() {
            if(taskId){
                const res = await getTask(taskId,getTaskError)
                setTask(res.data)
                setValue('name', res.data.name)
                setValue('richDescription', res.data.richDescription)
                setValue('size', res.data.size)
                setValue('deadline', new Date(res.data.deadline))
            }else{
                setValue('deadline', new Date(moment().add(1,'M').add(1,'days')))
            }
        }
   
        loadSizes()
        loadTask()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(project){
            return(<h1 className='font-bold text-2xl'>{project.name} - Agregar una tarea</h1>)
        }else{
            return(<h1 className='font-bold text-2xl'>Editar una tarea</h1>)
        }
    }
    

    const handleSave = handleSubmit(async data => {
        if(project && project.id){
            const payload = {
                name: data.name,
                size: parseInt(data.size),
                richDescription: data.richDescription,
                deadline: moment(new Date(data.deadline)).format('YYYY-MM-DD')
            }
    
            await createTaskProject(project.id, payload, createTaskSuccess, createTaskError)
        }
    })
    const handleUpdate = handleSubmit(async data => {
        if(taskId){
            const payload = {
                name: data.name,
                size: parseInt(data.size),
                richDescription: data.richDescription,
                deadline: moment(new Date(data.deadline)).format('YYYY-MM-DD')
            }
    
            await updateTask(taskId, payload, updateTaskSuccess, updateTaskError)
        }
    })

    const createTaskSuccess = (res => {
        showSuccess('Tarea creada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createTaskError = (error => {
        showError(`Error al crear la tarea. ${error.message}. ${error.response.data}`)
    })

    const updateTaskSuccess = (res => {
        showSuccess('Tarea actualizada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const updateTaskError = (error => {
        showError(`Error al actualizar la tarea. ${error.message}. ${error.response.data}`)
    })

    const renderSizes = () => {
        return sizes.map((option, index) => (
            <option key={option.value} value={option.value}>{option.size}</option>
        ));
    }

    const renderButton = () => {
        if(!taskId)
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
        else
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleUpdate}>Actualizar</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <div className="flex">
                        <input
                            type="text"
                            placeholder="Nombre"
                            {...register("name", { required: true })}
                            className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                        />
                        {errors.name && <span>Campo requerido</span>}

                        <select
                            name="size"
                            placeholder="size"
                            {...register("size", { required: true })}
                            className=' bg-blue-100 mb-3 ml-2 rounded-lg'
                        >
                            <option value="">Tamaño</option>
                            {renderSizes()}
                        </select>
                        <div className="flex flex-col">
                        <div className="ml-2 h-6">Posible deadline</div>
                        <Controller
                            control={control}
                            name="deadline"
                            rules={{ required: true }}
                            render={({
                                field: { onChange, name, value },
                                fieldState: { invalid, isDirty },
                                formState: { errors },
                            }) => (
                                <>
                                    <DatePicker
                                        value={value || ""}
                                        onChange={(date) => {
                                            onChange(date?.isValid ? date : "");
                                        }}
                                        format={"DD/MM/YYYY"}
                                        inputClass=' bg-blue-100 rounded-lg ml-2'
                                    />
                                </>
                            )}
                        />
                        {errors.deadline && <span className='font-bold text-red-500'>Fecha de exp. es requerido</span>}
                        </div>
                    </div>

                    <textarea
                        rows="3"
                        placeholder="Descripción"
                        {...register("richDescription", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.richDescription && <span>Campo requerido</span>}

                </form>
                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}